import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { FaChevronLeft } from "react-icons/fa";
import { IoCard } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { CartContext } from "../../../contexts/MiniStore/CartContext";
import { getToken } from "../../../DataApi/miniStore/getToken";
import { proceedPayment } from "../../../DataApi/miniStore/proceedPayment";
import { enqueueSnackbar } from "notistack";
import { onApplyPromoCode } from "../../../DataApi/miniStore/onApplyPromoCode";
import { completeTransaction } from "../../../DataApi/miniStore/completeTransaction";
import usePaymentResponse from "./hooks/usePaymentResponse";
import { useSession } from "../../../authentications/SessionContext";

const CheckoutSummary = ({
  theme,
  deliveryType,
  paymentType,
  paymentAcquirers,
  isSelectedShipping,
}) => {
  const {
    subTotal,
    total,
    currency,
    shippingCost,
    promoDiscount,
    promoCode,
    setPromoCode,
    applyPromoCode,
    message,
    cart,
    cartTax,
  } = useContext(CartContext);
  const { authenticated } = useSession();
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const { handlePaymentRedirectMethod } = usePaymentResponse();
  const navigate = useNavigate();
  // console.log("isSelectedShipping", isSelectedShipping);
  const submitPromoCode = async (e) => {
    e.preventDefault();
    try {
      let tokenResp = await getToken();
      if (!tokenResp.status === 200) {
        // console.log("Failed to fetch CSRF token!!!!", tokenResp);
        return;
      }
      if (tokenResp.status === 200) {
        let promoResponse = await onApplyPromoCode({
          sale_order_id: cart?.[0]?.order_id,
          coupon: promoCode,
          token: tokenResp?.token,
        });
        // console.log("promoResponse", promoResponse);
      }
    } catch (error) {
      enqueueSnackbar("Failed to apply promo code! Please try again.", {
        variant: "error",
      });
    }
  };
  // console.log("cart", cart);

  const onClickPay = async () => {
    try {
      setIsLoadingPayment(true);
      const selectedMode = paymentAcquirers?.find(
        (mode) => mode.id === paymentType
      );
      // console.log(paymentAcquirers, paymentType, selectedMode);
      // console.log("paymentType", paymentType);
      let endpoint = "/mini-store/payment-successful";
      const fullUrl = `${window.location.origin}${endpoint}`;
      let transactionResponse = await completeTransaction({
        acquirer_id: paymentType,
        access_token: "",
        callback_method: "",
        error_url: "",
        invoice_id: "",
        order_id: "",
        success_url: fullUrl,
      });

      await handlePaymentRedirectMethod(
        transactionResponse?.result,
        selectedMode?.provider === "thawani"
      );
      setIsLoadingPayment(false);
      // console.log("transactionResponse", transactionResponse);
    } catch (error) {
      setIsLoadingPayment(false);
      enqueueSnackbar("Payment failed! Please try again.", {
        variant: "error",
      });
    }
  };
  useEffect(() => {
    // console.log("subTotal, total", subTotal, total);
  }, [subTotal, total, currency]);

  return (
    <CheckoutSummaryWrapper theme={theme}>
      <SummaryTitle>Checkout Summary</SummaryTitle>
      <CharacterLine />
      <CheckoutDetails>
        <DetailKey>Subtotal</DetailKey>
        <SubtotalValue>{subTotal}</SubtotalValue>
      </CheckoutDetails>
      <CheckoutDetails>
        <DetailKey>Taxes</DetailKey>
        <SubtotalValue>
          {currency} {cartTax}
        </SubtotalValue>
      </CheckoutDetails>
      <CheckoutDetails>
        <DetailKey>Discount</DetailKey>
        <DiscountValue theme={theme}>
          - {currency} {promoDiscount}
        </DiscountValue>
      </CheckoutDetails>
      <CheckoutDetails>
        <DetailKey>Shipping</DetailKey>
        <ShippingValue theme={theme}>
          {currency} {shippingCost}
        </ShippingValue>
      </CheckoutDetails>
      <PromoForm theme={theme} onSubmit={submitPromoCode}>
        <PromoInput
          theme={theme}
          type="text"
          placeholder="Apply promo code"
          value={promoCode}
          onChange={(e) => setPromoCode(e.target.value)}
        />
        <PromoBtn theme={theme} type="submit">
          Apply
        </PromoBtn>
      </PromoForm>
      <PromoMessage theme={theme} type={message?.type} show={message?.text}>
        {message?.text}
      </PromoMessage>

      <CheckoutTotal theme={theme}>
        <TotalKey theme={theme}>Total</TotalKey>
        <TotalValue theme={theme}>{total}</TotalValue>
      </CheckoutTotal>
      <ContinueShopping theme={theme} to="/mini-store/shop">
        <FaChevronLeft />
        <span>Continue Shopping</span>
      </ContinueShopping>
      <Pay
        theme={theme}
        onClick={onClickPay}
        disabled={authenticated || isLoadingPayment || !isSelectedShipping}
        // disabled={!paymentType || !deliveryType}
      >
        <IoCard />
        Pay
      </Pay>
    </CheckoutSummaryWrapper>
  );
};

export default CheckoutSummary;

const PromoForm = styled.form`
  position: relative;
  width: 100%;
`;

const PromoInput = styled.input`
  width: 100%;
  height: 65px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  margin: 10px 0px 10px 0px;
  padding: 1.5rem;
  background: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  // border: none;
  font-size: 18px;
  padding-right: 125px;
  &::placeholder {
    color: ${({ theme }) => theme.primaryColor.primary};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primaryColor.primary} !important;
    outline-offset: 1px;
  }
`;

const PromoBtn = styled.button`
  position: absolute;
  right: 15px;
  height: 40px;
  top: 50%;
  transform: translateY(-50%);
  font-family: Outfit, sans-serif;
  font-weight: 600;
  font-size: 16px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  color: ${({ theme }) => theme.textColor.primary};
  background: ${({ theme }) => theme.primaryColor.primary};
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  // border: none;
  padding: 5px 10px;
  cursor: pointer;
`;
export const PromoMessage = styled.div`
  font-family: Outfit, sans-serif;
  padding: 0px 0px 10px 10px;
  border-radius: 0.15rem;
  font-size: 14px;
  text-align: start;
  color: ${({ type }) => (type === "error" ? "#dc3545" : "#666666")};
  display: ${({ show }) => (show ? "block" : "none")};
`;

const CheckoutSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem;
  height: fit-content;
  flex: 0 0 calc(30% - 10px);
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  background: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
`;
const SummaryTitle = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0px;
  color: #666666;
`;
const CharacterLine = styled.div`
  border: 1px solid #9c9a9a;
  background: #9c9a9a;
  width: 100%;
  height: 2px;
  border-width: 1px;
  margin: 10px 0px 22px 0px;
`;
const CheckoutDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 5px;
`;
const DetailKey = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0px;
  color: #292727;
`;
const SubtotalValue = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0px;
  color: #666666;
`;
const ShippingValue = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0px;
  color: #666666;
`;
const DiscountValue = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.primaryColor.primary};
`;
const CheckoutTotal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 65px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  margin: 40px 0px 10px 0px;
  padding: 1.5rem;
  background: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
`;
const TotalKey = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  color: ${({ theme }) => theme.primaryColor.primary};
  @media (max-width: 375px) {
    font-size: 20px;
  }
`;
const TotalValue = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  color: ${({ theme }) => theme.primaryColor.primary};
  @media (max-width: 375px) {
    font-size: 20px;
  }
`;
const ContinueShopping = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 65px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  margin: 10px 0px;
  padding: 1.5rem;
  cursor: pointer;
  text-decoration: none !important;
  font-family: Outfit, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  background: ${({ theme }) => theme.textColor.primary};
  color: ${({ theme }) => theme.primaryColor.primary} !important;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  overflow: hidden;

  svg {
    color: ${({ theme }) => theme.primaryColor.primary};
    margin: 0px 3px;
    flex-shrink: 0;
  }

  // Add span to wrap text
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    line-height: 30px;
  }
  @media (max-width: 375px) {
    font-size: 20px;
  }
`;
const Pay = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 65px;
  border-radius: 0.15rem;
  border-width: 1px;
  margin: 10px 0px;
  padding: 1.5rem;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-family: Outfit, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  background: ${({ disabled, theme }) =>
    disabled ? "#ddd" : theme.primaryColor.primary};
  border: 1px solid
    ${({ disabled, theme }) => (disabled ? "#ddd" : theme.primaryColor.primary)};
  color: ${({ disabled, theme }) =>
    disabled ? "#aaa" : theme.textColor.primary} !important;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  transition: all 0.3s ease;

  svg {
    color: ${({ disabled, theme }) =>
      disabled ? "#aaa" : theme.textColor.primary};
    margin: 0px 3px;
    width: 34px;
    height: 27px;
  }
  @media (max-width: 375px) {
    font-size: 20px;
  }
`;
